import { render, staticRenderFns } from "./BudgetAccounting.vue?vue&type=template&id=4ce06e42&scoped=true&"
import script from "./BudgetAccounting.vue?vue&type=script&lang=ts&"
export * from "./BudgetAccounting.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetAccounting.vue?vue&type=style&index=0&id=4ce06e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce06e42",
  null
  
)

export default component.exports